import safet from "../media/safet.png";
import dino from "../media/dino.png";
import meris from "../media/meris.png";
import aida from "../media/aida.png";
import { AiFillInstagram, AiFillBehanceCircle } from "react-icons/ai";
const people = [
  {
    photo: safet,
    name: "Safet Pojskić",
    position: "Web developer",
    about:
      " I'm a former Pharmacy technician who studied Pharmacy for 2 years and completely abandoned it because I wanted to study computer science. I've always had passion for computers, software and hardware.",
    delay: 0,
    github: "https://github.com/MagicPojska",
    linkedin: "https://www.linkedin.com/in/mrpojskic/",
    social: "https://www.instagram.com/magic_pojska/",
    social__icon: <AiFillInstagram />,
    portfolio: "https://www.safetpojskic.com/",
  },
  {
    photo: dino,
    name: "Dino Šišić",
    position: "CEO & Founder",
    about:
      "BSc. of Computer Science and Engineering. I have a background in Web Design, Embedded Systems, Electrical Circuits, Astrophysics, and Project Management. My interests come from many STEM fields.",
    delay: 100,
    github: "https://github.com/Nodarra",
    linkedin: "https://www.linkedin.com/in/dino-sisic-1795831b8/",
    social: "https://www.instagram.com/nodarra/",
    social__icon: <AiFillInstagram />,
    portfolio: "https://www.dinosisic.com/",
  },
  {
    photo: meris,
    name: "Meris Stupar",
    position: "Graphic & UX/UI Designer",
    about:
      " I am very ambitious and friendly person ready to devote my time for learning new things and making an impact from this side of machine. Working with me gives you a team player who is willing to improve.",
    delay: 200,
    github: "https://github.com/WendigoM3ris",
    linkedin: "https://www.linkedin.com/in/meris-stupar-84610719a/",
    social: "https://www.behance.net/merisstupar",
    social__icon: <AiFillBehanceCircle />,
    portfolio: "https://merisstupar.netlify.app/",
  },
  {
    photo: aida,
    name: "Aida Mujčinović",
    position: "Web Developer",
    about:
      "BSc. of Software Engineering at the PTF in Zenica. I have experience in working with JavaScript frameworks and marketing. ",
    delay: 300,
    github: "https://github.com/mujcinovicaida",
    linkedin:
      "https://www.linkedin.com/in/aida-muj%C4%8Dinovi%C4%87-578a631aa/",
    social: "https://www.instagram.com/mujcinovic.aida/?hl=en",
    social__icon: <AiFillInstagram />,
    portfolio: "#",
  },
];

export default people;
